import distributionStatuses from "astrid-firestore/src/api/distribution/constants/distributionStatuses";

const distributionStatusColors = {
	[distributionStatuses.QUEUED]: "blue",
	[distributionStatuses.PENDING]: "blue",
	[distributionStatuses.SCHEDULED]: "blue",
	[distributionStatuses.INITIALIZED]: "blue",
	[distributionStatuses.RUNNING]: "blue",
	[distributionStatuses.CANCELLED]: "black",
	[distributionStatuses.COMPLETED]: "green",
	[distributionStatuses.FAILED]: "red",
};

export default distributionStatusColors;
